import UserDataManager from "../../../../manager/user_manager";
import Utility from "../../../../utility/utility";
import { ChatType } from "./chat_view";
import EventManager from "../../../../manager/event_manager";
import ComponentBase from "../../../public/component/component_base";
import ModelData, { IUserData } from "../../../public/model_data";
import PublicPlayerAvatar from "../../../public/component/public_player_avatar";

const { ccclass, property } = cc._decorator;

@ccclass
export class ChatCellView extends ComponentBase {

  @property(cc.Node)
  myNode: cc.Node = null;

  @property(PublicPlayerAvatar)
  myAvatar: PublicPlayerAvatar = null;

  @property( cc.Label)
  myContent: cc.Label = null;

  @property(cc.Node)
  myBg: cc.Node = null;

  @property(cc.Node)
  myHorn: cc.Node = null;

  @property(cc.Node)
  otherNode: cc.Node = null;

  @property(PublicPlayerAvatar)
  otherAvatar: PublicPlayerAvatar = null;

  @property(cc.Label)
  otherContent: cc.Label = null;

  @property(cc.Node)
  otherBg: cc.Node = null;

  @property(cc.Node)
  otherHorn: cc.Node = null;

  curLab: cc.Label | cc.RichText = null;

  private chatType : ChatType;

  private data: any;

  private userId: number

  private lineNum : number;

  setContent(isMe: boolean, content: string, chatType: ChatType, showHorn?: boolean) {

    this.myNode.active = isMe;
    this.otherNode.active = !isMe;
    this.curLab = isMe ? this.myContent : this.otherContent;

    let curBg = isMe ? this.myBg : this.otherBg;

    // this.curLab.overflow = cc.Label.Overflow.NONE
    // this.curLab.node.width = 0;

    let txt = this.checkTxt(content);
    this.curLab.string = txt;
    this.lineNum = txt.split('\n').length;

    //@ts-ignore
    // this.curLab._forceUpdateRenderData(true);

    // let maxWidth = chatType == ChatType.worldChat ? 700 : 450;
    // if (this.curLab.node.width > maxWidth) {
    //   this.curLab.node.width = maxWidth;
    //   this.curLab.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
    //   //@ts-ignore
    //   this.curLab._forceUpdateRenderData(true);
    // }
   
    // curBg.width =  this.curLab.node.width + 55;
    // curBg.height =  this.curLab.node.height + 20;
  
    this.setHorn(isMe, chatType, showHorn)
  }

  setData(data) {
    this.data = data.data;
    this.chatType = data.type;
        
  }

  setUserId(userId : number){
    this.userId = userId;
    let avatar: PublicPlayerAvatar
    if(userId == ModelData.instance.roleData.id){
      avatar = this.myAvatar
    }else{
      avatar = this.otherAvatar
    }
    avatar.maxNameCharLen = 10
    avatar.show(true, userId)
  }

  setHorn(isMe: boolean, chatType: ChatType, showHorn?: boolean) {

    if (!showHorn) {

      if (this.myHorn) this.myHorn.active = false;
      if (this.otherHorn) this.otherHorn.active = false;
    }

    else if (chatType == ChatType.worldChat) {

      this.myHorn.active = isMe;
      this.otherHorn.active = !isMe;

      if (isMe) {

        let xpos = this.myBg.position.x;
        let width = this.curLab.node.getContentSize().width + 50;
        this.myHorn.setPosition(xpos - width, this.myHorn.position.y);
      }

    }
  }

  setAvatar(isme: boolean, url: string,gender : number) {
    // let self = this;
    // let userId = self.userId;
    // UserDataManager.getAvatarSprite(url, (spriteFrame) => {
    //   if (userId == self.userId) {       
    //     let icon = isme ? self.myAvatar : self.otherAvatar;
    //     icon.spriteFrame = spriteFrame;
    //   }
    // },false,gender);
  }

  setName(isMe: boolean, name: string) {
    // let nameText = isMe ? this.myName : this.otherName;
    // nameText.string = Utility.filterPlayerName(name,10)
  }

  getHeight(): number {
    //console.log(" content " , this.curLab.string + " lineNum ", this.lineNum)
    return 50.4 + (this.lineNum - 1)* this.curLab.lineHeight;
    //return this.curLab.node.height;
  }

  checkTxt(allContent: string) {

    //return allContent;
    let check = this.chatType == ChatType.worldChat ? 18 : 11;
    if (allContent.length < check) {
      return allContent;
    }

    let clampStr = allContent;

    let addtionStr : string[]= [];

    while(true){

      let clampInfo = Utility.strClampIndex(clampStr,check * 2,"");   

      let add : string = "";
      addtionStr.forEach(str=>{
        add += str
      })
      
      if (add + clampInfo.str == allContent) {
        
        if (!add) {          
          return allContent;
        }else{
          
          let result = "";
          addtionStr.forEach( (str,index)=>{
            result += str + "\n";                  
          })
          return result + clampInfo.str;
        }
      }        
      addtionStr.push(clampInfo.str);

      clampStr = clampStr.substring(clampInfo.index);
    } 
  }

  onClickAvatar() {
    if (this.userId) {
      Utility.playButtonSound();
      EventManager.instance.dispatch("Event_Chat_Click_OtherInfoAvatar", this.userId)
    }
  }



}
